module.exports = __webpack_public_path__ + "static/media/Theriot_Official_Resume.8597d98f.pdf";